var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTradeServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9897 15.9908L14.0497 11.0508L11.9297 13.1708L16.8697 18.1108C17.4597 18.7008 18.4097 18.7008 18.9897 18.1108C19.5697 17.5208 19.5697 16.5708 18.9897 15.9908Z",
    fill: "#5D688B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6491 8.00078C17.5791 8.00078 19.1491 6.43078 19.1491 4.50078C19.1491 3.92078 18.9891 3.38078 18.7391 2.90078L16.0391 5.60078L14.5491 4.11078L17.2491 1.41078C16.7691 1.16078 16.2291 1.00078 15.6491 1.00078C13.7191 1.00078 12.1491 2.57078 12.1491 4.50078C12.1491 4.91078 12.2291 5.30078 12.3591 5.66078L10.5091 7.51078L8.72906 5.73078C9.11906 5.34078 9.11906 4.71078 8.72906 4.32078L8.01906 3.61078L10.1391 1.49078C8.96906 0.320781 7.06906 0.320781 5.89906 1.49078L3.07906 4.32078C2.68906 4.71078 2.68906 5.34078 3.07906 5.73078L3.78906 6.44078H1.24906C1.05906 6.44078 0.879063 6.51078 0.749063 6.65078C0.469062 6.93078 0.469062 7.37078 0.749063 7.65078L3.28906 10.1908C3.56906 10.4708 4.00906 10.4708 4.28906 10.1908C4.41906 10.0608 4.49906 9.88078 4.49906 9.69078V7.15078L5.19906 7.85078C5.58906 8.24078 6.21906 8.24078 6.60906 7.85078L8.38906 9.63078L2.03906 15.9808C1.44906 16.5708 1.44906 17.5208 2.03906 18.1008C2.62906 18.6908 3.57906 18.6908 4.15906 18.1008L14.4791 7.79078C14.8491 7.92078 15.2391 8.00078 15.6491 8.00078Z",
    fill: "#5D688B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTradeServices);
export default __webpack_public_path__ + "static/media/nav-trade-services.0b1d9bbe.svg";
export { ForwardRef as ReactComponent };